$('.btn-add-addition-comment').on('click', function () {
    showAdditionCommentModal();
});


$('.btn-edit-validation-comment').on('click', function () {
    showEditValidationCommentModal($(this).data('url'));
});

$('.btn-delete-validation-comment').on('click', function () {
    var url = $(this).data('url').toString();
    if (confirm("Are you sure you want to delete this comment?")) {
        window.location.replace(url);
    }
});

function showEditValidationCommentModal(formUrl) {

    $.post(formUrl, '', function (data) {
        $("#edit_urgent_comment_modal_content").html(data);

        $('#edit_urgent_comment_modal').modal('show');
    });
}

function showAdditionCommentModal() {

    var formUrl = '/plat-maps/comment?plantId=' + $("#plant-id").val() + '&addition=' + encodeURIComponent($('#addition-name').val());

    $.post(formUrl, '', function (data) {
        $("#comment-modal-content").html(data);


        $('#urgent-checkbox-area').on('click', function () {
            var lotField = $('#subdivision_comment_lot');
            var blockField = $('#subdivision_comment_block');
            var unitField = $('#subdivision_comment_unit');
            var sublotField = $('#subdivision_comment_sublot');
            var tractField = $('#subdivision_comment_tract');

            if ($('#subdivision_comment_urgent').is(':checked')) {
                lotField.prop('disabled', true);
                lotField.val('ALL');
                blockField.prop('disabled', true);
                blockField.val('ALL');
                unitField.prop('disabled', true);
                unitField.val('ALL');
                sublotField.prop('disabled', true);
                sublotField.val('ALL');
                tractField.prop('disabled', true);
                tractField.val('ALL');
            } else {
                lotField.prop('disabled', false);
                lotField.val('');
                blockField.prop('disabled', false);
                blockField.val('');
                unitField.prop('disabled', false);
                unitField.val('');
                sublotField.prop('disabled', false);
                sublotField.val('');
                tractField.prop('disabled', false);
                tractField.val('');
            }
        });

        $('#comment-modal').modal('show');
    });
}